import { DistanceUnit, DateUtils, formatDistance } from "@grandvisionhq/utils";
const formatDistanceQueryData = (data, options) => {
  let { distanceUnit } = options;
  const { locale } = options;
  const { distance, timeByCar, timeByFoot } = data;
  if (distance && distance < 1e3) {
    if (distanceUnit === DistanceUnit.meter || distanceUnit === DistanceUnit.km) {
      distanceUnit = DistanceUnit.meter;
    }
  }
  return {
    distance: distance != void 0 ? formatDistance(distance, distanceUnit, { separator: " " }) : distance,
    timeByCar: timeByCar != void 0 ? DateUtils.minutesToHM(timeByCar, locale) : timeByCar,
    timeByFoot: timeByFoot != void 0 ? DateUtils.minutesToHM(timeByFoot, locale) : timeByFoot
  };
};
export {
  formatDistanceQueryData
};
//# sourceMappingURL=adapters.js.map
